import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
import _extends from "@babel/runtime/helpers/extends";

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  padding: ", "px;\n  box-sizing: border-box;\n  width: 100%;\n  ", "\n\n  @media screen and (max-width: ", "px) {\n    ", ";\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  padding: 30px;\n  box-sizing: border-box;\n  width: 100%;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n  text-align: right;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 30px;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  align-self: center;\n  line-height: 30px;\n  font-size: 22px;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  display: flex;\n  flex-flow: row nowrap;\n  justify-content: space-between;\n  font-weight: 600;\n  font-size: 22px;\n  line-height: 30px;\n  padding: ", "px;\n  padding-bottom: 0px;\n  position: relative;\n  ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import { MiniIcon } from '@acorns/icons';
import styled from '../utils/styling/styled-components';
import { Card } from '../Card';
import { Heading } from '../Typography';

var CardWidget = function CardWidget(props) {
  return /*#__PURE__*/React.createElement(Card, _extends({}, props, {
    className: props.className
  }), props.children);
};

var paddingMap = {
  large: 80,
  medium: 50,
  small: 30,
  none: 0
};
var Eyebrow = styled.div(_templateObject(), function (props) {
  return props.theme.colors.slate;
}, function (_ref) {
  var _ref$padding = _ref.padding,
      padding = _ref$padding === void 0 ? 'small' : _ref$padding;
  return paddingMap[padding];
}, function (props) {
  return props.onClick && 'cursor: pointer;';
});
var LabelContainer = styled(Heading)(_templateObject2());
var ArrowContainer = styled.div(_templateObject3());
var CardWidgetFooter = styled.div(_templateObject4());

var CardWidgetEyebrow = function CardWidgetEyebrow(props) {
  return /*#__PURE__*/React.createElement(Eyebrow, {
    padding: props.padding,
    onClick: props.onEyebrowClick
  }, props.showArrow ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(LabelContainer, null, props.eyebrowContent), /*#__PURE__*/React.createElement(ArrowContainer, null, /*#__PURE__*/React.createElement(MiniIcon, {
    darkMode: false,
    icon: MiniIcon.Icon.ArrowFv
  }))) : props.eyebrowContent);
};

var CardWidgetContentContainer = styled.div(_templateObject5(), function (_ref2) {
  var _ref2$padding = _ref2.padding,
      padding = _ref2$padding === void 0 ? 'small' : _ref2$padding;
  return paddingMap[padding];
}, function (props) {
  return props.isContentCenterAligned && "\n    margin: auto; // Makes the content take up center aligned within available space and pins footer to the bottom.\n  ";
}, function (props) {
  return props.theme.breakpoints.sm;
}, function (props) {
  return props.eyebrowContent ? 'padding: 30px 30px 50px' : '50px 30px';
});

var CardWidgetContent = function CardWidgetContent(props) {
  var _props$dataTestId, _props$dataTestId2;

  return /*#__PURE__*/React.createElement(React.Fragment, null, props.eyebrowContent && /*#__PURE__*/React.createElement(CardWidgetEyebrow, _extends({
    "data-testid": "".concat((_props$dataTestId = props.dataTestId) !== null && _props$dataTestId !== void 0 ? _props$dataTestId : 'a4_card_content', "_eyebrow")
  }, props)), /*#__PURE__*/React.createElement(CardWidgetContentContainer, _extends({
    "data-testid": (_props$dataTestId2 = props.dataTestId) !== null && _props$dataTestId2 !== void 0 ? _props$dataTestId2 : 'a4_card_content'
  }, props), props.children));
};

export { CardWidget, CardWidgetFooter, CardWidgetContent, CardWidgetEyebrow };